
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { HiDocumentText } from 'react-icons/hi2'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import ProviderSummaryModal from './ProviderSummaryModal'
import api from '../../../utils/api'

import '../../client/ListRow/ListClientRow.css'
import './ListProviderRow.css'

import EditProvider from '../EditProvider'
import { formatCNPJ } from '../../../shared/functions/cnpjFormat'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

function ListProviderRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditProvider, setModalEditProvider] = useState(false)
    const [providerId, setProviderId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [providerName, setProviderName] = useState("")
    const [modalSummary, setModalSummary] = useState(false)
    const [summaryItem, setSummaryItem] = useState(null)

    async function deleteProvider(id) {
        let msgType = 'success'
        const data = await api.delete(`/provider/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <div className='client-row-text'>
                            <span className='client-row-name'>{item.name}</span>
                            <div className='client-row-meta'>
                                {item.personType && (
                                    <span className={`client-type-badge client-type-${item.personType}`}>
                                        {item.personType === 'juridica' ? 'PJ' : 'PF'}
                                    </span>
                                )}
                                {item.personType === 'juridica' && item.CNPJ && (
                                    <span className='client-row-doc'>{formatCNPJ(item.CNPJ)}</span>
                                )}
                                {item.personType === 'fisica' && item.CPF && (
                                    <span className='client-row-doc'>{item.CPF}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionView &&
                            <HiDocumentText className='provider-icon-row-summary' title='Ver Resumo' onClick={() => { setSummaryItem(item); setModalSummary(true) }} />
                        }
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setProviderId(item._id); setModalEditProvider(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setProviderId(item._id); setProviderName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditProvider}
                changeStatus={setModalEditProvider}
                t={3}
                w={88}
                h={90}
                content={
                    <EditProvider id={providerId} handleOnSuccess={() => { setModalEditProvider(false); handleOnSuccess() }} btCancelAction={() => setModalEditProvider(false)} />
                }
            />

            {modalSummary && (
                <ProviderSummaryModal
                    provider={summaryItem}
                    onClose={() => setModalSummary(false)}
                />
            )}

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteProvider(providerId)}
                message="Deseja realmente excluir esse fornecedor?"
                itemName={providerName}
            />

        </div>
    )
}

export default ListProviderRow
